/* eslint-disable no-restricted-globals,react/jsx-props-no-spreading,react-hooks/exhaustive-deps,no-unused-expressions */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Row,
  Space,
  Table,
  Tooltip,
} from "antd";
import isEmpty from "lodash/isEmpty";
import { useHistory } from "react-router-dom";
import moment from "moment";
import ModalWindow from "../ModalWindow/ModalWindow";
import pencilIcon from "../../img/edit.svg";
import pencilPlus from "../../img/pencil-plus.svg";
import "./ChargesDetails.less";
import { displayFormat, toDisplayFormat, toHttpFormatStartOfDay } from "../../lib/utils/formatDate";
import { checkIsLoading } from "../../lib/utils/checkLoadingStatus";
import { adjustmentIcon, chargeIcon } from "../../lib/icons";
import { buildQueryStringWithObjectParams, getAccountFullName } from "../../lib/utils";
import {
  deleteAdjustment,
  fetchChargesDetails,
  handleCheckUrlForRemovingChargeSessionStorage,
  recreateFinancialDocumentsPatch,
} from "../../store/slices/charges";
import del from "../../img/delete.svg";
import SpanNumberFormat from "../common/SpanNumberFormat";
import InputNumberFormat from "../common/InputNumberFormat";
import { baseUrl } from "../../lib/routes/baseUrl";
import versionsTableUtils from "../../lib/utils/versionsTableUtils";
import { ReactComponent as WarningIco } from "../../img/warning-icon.svg";

const ChargesDetails = ({ chargesDetails, chargesDetailsLoading }) => {
  const dispatch = useDispatch();
  const { agreement } = useSelector((state) => state.agreements);
  const { rateType } = useSelector((state) => state.rtkDictionaries);
  const { account } = useSelector((state) => state.accounts);
  const [newDataChargesAdjustments, setNewDataChargesAdjustments] = useState([]);
  const [dataChargesBillFactur, setDataChargesBillFactur] = useState([]);
  console.log({ dataChargesBillFactur });
  const [dataChargesBill, setDataChargesBill] = useState([]);
  const [dataAdjustments, setDataAdjustments] = useState([]);
  const [visibleModal, setVisibleModal] = useState(false);
  const [visibleModalConfirm, setVisibleModalConfirm] = useState(false);
  const [visibleModalConfirmCreateUpdate, setVisibleModalConfirmCreateUpdate] = useState(false);
  const [adjustmentRecord, setAdjustmentRecord] = useState("");
  const [adjustmentCountForCheckBeforeRemove, setAdjustmentCountForCheckBeforeRemove] = useState(
    ""
  );
  const [visibleCorrectiveInvoiceModal, setVisibleCorrectiveInvoiceModal] = useState(false);
  const [visibleSubmitCorrectiveInvoiceModal, setVisibleSubmitCorrectiveInvoiceModal] = useState(
    false
  );

  const [charge, setCharge] = useState({});
  const [adjustments, setAdjustments] = useState([]);

  const [isFirstClick, setIsFirstClick] = useState(false);
  const [isAddQuest, setIsAddQuest] = useState(false);

  // Начисление, корректировки, счета-фактуры, счета
  useEffect(() => {
    if (!isEmpty(chargesDetails)) {
      setCharge(chargesDetails.resultSearchChargeByTransactionID || {});
      setAdjustments(chargesDetails.resultAjustmentsParentTransactionId || []);
    }
  }, [chargesDetails]);

  // Данные раздела "Информация по начислениям": Начисления/корректировки
  useEffect(() => {
    const newAdjusments =
      (Array.isArray(chargesDetails?.resultAjustmentsParentTransactionId) &&
        chargesDetails.resultAjustmentsParentTransactionId.filter(
          ({ adjustmentTypeId }) => adjustmentTypeId === 1
        )) ||
      [];
    setNewDataChargesAdjustments(
      [chargesDetails?.resultSearchChargeByTransactionID, ...newAdjusments]
        .filter(Boolean)
        .map((item) => ({
          key: item.chargeId,
          ...item,
          serviceTypeName: item.serviceId ? item?.serviceTypeName : item?.chargeName,
          period: {
            from: item?.chargePeriodFrom ? toDisplayFormat(item?.chargePeriodFrom) : "",
            to: item?.chargePeriodTo ? toDisplayFormat(item?.chargePeriodTo) : "",
          },
        }))
    );
  }, [chargesDetails]);

  // Данные раздела "Информация по начислениям": Учтено в счете-фактуре
  useEffect(() => {
    const chargeInvoiceExtNum = chargesDetails?.resultSearchChargeByTransactionID?.invoiceExtNum;
    if (chargeInvoiceExtNum && chargesDetails?.resultInvoiceCalculate) {
      const chargeInvoiceDate = chargesDetails?.resultSearchChargeByTransactionID?.invoiceDate;

      const data =
        Object.entries(chargesDetails.resultInvoiceCalculate)
          .filter(([invoiceExtNum, invoiceExtData]) =>
            invoiceExtData.find((invoiceExtDataElement) => {
              return (
                moment(chargeInvoiceDate).isSame(invoiceExtDataElement.invoiceDate) &&
                invoiceExtNum === chargeInvoiceExtNum
              );
            })
          )
          .map(([invoiceExtNum, billFacture]) => ({
            key: invoiceExtNum,
            ...billFacture[0],
            invoiceExtNum,
            period: {
              from: billFacture[0]?.resultMinDate
                ? toDisplayFormat(billFacture[0].resultMinDate)
                : "",
              to: billFacture[0]?.resultMaxDate
                ? toDisplayFormat(billFacture[0].resultMaxDate)
                : "",
            },
          })) || [];
      // .map(([invoiceExtNum, billFacture]) => ({
      //   key: invoiceExtNum,
      //   ...billFacture,
      //   invoiceExtNum,
      //   period: {
      //     from: billFacture?.resultMinDate ? toDisplayFormat(billFacture.resultMinDate) : "",
      //     to: billFacture?.resultMaxDate ? toDisplayFormat(billFacture.resultMaxDate) : "",
      //   },
      // })) || [];
      setDataChargesBillFactur(data);
    } else {
      setDataChargesBillFactur([]);
    }
  }, [chargesDetails]);

  // Данные раздела "Информация по начислениям": Учтено в счете
  useEffect(() => {
    setDataChargesBill(
      (chargesDetails?.resultBills || [])
        .filter(
          ({ billId }) =>
            billId > 0 && billId === chargesDetails.resultSearchChargeByTransactionID?.billId
        )
        .map((item) => ({
          key: item.billId,
          ...item,
          period: {
            from: item?.billPeriodFrom ? toDisplayFormat(item?.billPeriodFrom) : "",
            to: item?.billPeriodTo ? toDisplayFormat(item?.billPeriodTo) : "",
          },
        }))
    );
  }, [chargesDetails]);

  // Данные раздела "Информация по начислениям корректировочного счета-фактуры"
  useEffect(() => {
    const otherAdjusments = (
      (Array.isArray(chargesDetails?.resultAjustmentsParentTransactionId) &&
        chargesDetails.resultAjustmentsParentTransactionId.filter(
          ({ adjustmentTypeId }) => adjustmentTypeId !== 1
        )) ||
      []
    ).map((item) => ({
      key: item.chargeId,
      ...item,
      serviceTypeName: item.serviceId ? item?.serviceTypeName : item?.chargeName,
      period: {
        from: item?.chargePeriodFrom ? toDisplayFormat(item?.chargePeriodFrom) : "",
        to: item?.chargePeriodTo ? toDisplayFormat(item?.chargePeriodTo) : "",
      },
    }));

    const data = [];
    // Наполнение данных по корректировкам
    otherAdjusments.forEach((item) => {
      // Фиксация идентификатора СФ вида номер_дата для сравнения
      const numAndDateBillFacture = `${item.invoiceExtNum}_${moment(item.invoiceDate).format(
        displayFormat
      )}`;

      // Корректировки, ссылающиеся на одну и ту-же счет-фактуру (совпадение номера и даты), должны отображаться в одном блоке
      console.log("data", [...data]);
      const dataIdx = data.findIndex(
        (dataItem) => dataItem.numAndDateBillFacture === numAndDateBillFacture
      );
      if (dataIdx >= 0) {
        data[dataIdx].adjustments.push(item);
      } else {
        data.push({
          numAndDateBillFacture,
          adjustments: [item],
          billFactures: [],
          bills: [],
        });
      }
    });
    if (data.length > 0) {
      // Наполение данных по счетам-фактурам
      Object.entries(chargesDetails?.resultInvoiceCalculate || {}).forEach(
        ([invoiceExtNum, billFactures]) => {
          billFactures.forEach((billFacture) => {
            const numAndDateBillFacture = `${invoiceExtNum}_${moment(
              billFacture.invoiceDate
            ).format(displayFormat)}`;

            const dataIdx = data.findIndex((dataItem) => {
              return dataItem.numAndDateBillFacture === numAndDateBillFacture;
            });

            if (dataIdx >= 0) {
              data[dataIdx].billFactures.push({
                key: invoiceExtNum,
                ...billFacture,
                invoiceExtNum,
                period: {
                  from: billFacture?.resultMinDate
                    ? toDisplayFormat(billFacture.resultMinDate)
                    : "",
                  to: billFacture?.resultMaxDate ? toDisplayFormat(billFacture.resultMaxDate) : "",
                },
              });
            }
          });
        }
      );
      // Наполнение данных по счетам
      (data || []).forEach((dataItem, dataIdx) => {
        (chargesDetails?.resultBills || []).forEach((bill) => {
          const findBill = dataItem.adjustments.map(({ billId }) => billId).includes(bill.billId);

          if (findBill) {
            data[dataIdx].bills.push({
              key: bill.billId,
              ...bill,
              period: {
                from: bill?.billPeriodFrom ? toDisplayFormat(bill?.billPeriodFrom) : "",
                to: bill?.billPeriodTo ? toDisplayFormat(bill?.billPeriodTo) : "",
              },
            });
          }
        });
      });
    }
    setDataAdjustments(data);
  }, [chargesDetails]);

  // Отсутствие корректировки реализации закрытого периода
  const hasNoTaxInvoiceAdjustment = adjustments.length
    ? adjustments.every(({ adjustmentTypeId }) => adjustmentTypeId !== 3)
    : true;

  const [dataForm, setDataForm] = useState({
    parentTransactionId: "",
    serviceId: "",
    units: "",
    amount: "",
    dsc: "",
    chargeName: "",
    periodFrom: "",
    periodTo: "",
    param: "",
  });
  const defaultDataForm = {
    parentTransactionId: "",
    serviceId: "",
    units: "",
    amount: "",
    dsc: "",
    chargeName: "",
    periodFrom: "",
    periodTo: "",
    param: "",
  };

  const [form] = Form.useForm();
  const [formCorrectiveInvoice] = Form.useForm();
  const history = useHistory();
  const localStore = JSON.parse(sessionStorage.getItem("chargeFilters"));

  const editModal = () => {
    setVisibleModal(true);
  };

  const handleModalCancel = () => {
    setVisibleModal(false);
    setVisibleModalConfirm(false);
    setVisibleModalConfirmCreateUpdate(false);
    form.resetFields();
    Object.entries(dataForm).map(([param, value]) => [
      param,
      setDataForm({ ...defaultDataForm, param: value }),
    ]);
  };

  const onShowDeleteWindow = (rec) => {
    setAdjustmentRecord(rec);
    setVisibleModalConfirm(true);
  };

  const onShowCreateUpdateWindow = () => {
    form.validateFields().then(() => {
      setVisibleModalConfirmCreateUpdate(true);
    });
  };

  const handleCreateUpdateModalCancel = () => {
    setVisibleModalConfirmCreateUpdate(false);
  };

  const styles = {
    buttonIcon: {
      boxShadow: "none",
      border: 0,
    },
    btn: {
      width: "108px",
      height: "32px",
    },
  };

  useEffect(() => {
    setAdjustmentCountForCheckBeforeRemove(
      adjustments.reduce(
        (prev, curr) =>
          prev.find((a) => a.chargeId === curr.chargeId) ? prev : prev.push(curr) && prev,
        []
      )
    );
  }, [adjustments]);

  const chargesAndAdjustmentsInfoTableColumns = [
    {
      title: "",
      dataIndex: "isAdjustment",
      key: "isAdjustment",
      render: (text, record) => {
        if (record?.isAdjustment === 0) {
          return <Tooltip title="Начисление">{chargeIcon()}</Tooltip>;
        }
        return <Tooltip title="Корректировка">{adjustmentIcon()}</Tooltip>;
      },
    },
    {
      title: "Тип продукта",
      dataIndex: "serviceTypeName",
      key: "serviceTypeName",
    },
    {
      title: "Предложение",
      dataIndex: "offeringName",
      key: "offeringName",
    },
    {
      title: "Тип цены",
      dataIndex: "rateTypeId",
      key: "rateTypeId",
      render: (rateTypeId) => versionsTableUtils.geDicValueById(rateType, rateTypeId)?.name || "-",
    },
    {
      title: "Период",
      dataIndex: "period",
      key: "period",
      render: (period) => (
        <span>
          {period?.from} - {period?.to}
        </span>
      ),
    },
    {
      title: "Цена",
      dataIndex: "chargePrice",
      key: "chargePrice",
      render: (chargePrice) => SpanNumberFormat({ amount: chargePrice }),
    },
    {
      title: charge?.chargeUnits !== null ? "Количество" : "",
      dataIndex: "chargeUnits",
      key: "chargeUnits",
      width: charge?.chargeUnits === null && "1px",
      render: (chargeUnits) =>
        chargeUnits === null ? 0 : SpanNumberFormat({ amount: chargeUnits, fractSize: 0 }),
    },
    {
      title: "Единицы",
      key: "ed",
      render: () => "шт",
    },
    {
      title: "Сумма",
      dataIndex: "chargeAmount",
      key: "chargeAmount",
      render: (chargeAmount) => SpanNumberFormat({ amount: chargeAmount }),
    },
    {
      title: "НДС",
      dataIndex: "chargeTax",
      key: "chargeTax",
      render: (chargeTax) => SpanNumberFormat({ amount: chargeTax }),
    },
    {
      title: "Комментарий",
      dataIndex: "chargeDsc",
      key: "chargeDsc",
    },
    {
      dataIndex: "",
      key: "x",
      render: (v, rec) =>
        charge?.isAdjustment === 1 && !charge?.invoiceExtNum ? (
          <Button
            onClick={() => onShowDeleteWindow(rec)}
            className="delete-adjustment-btn"
            style={{ border: "none" }}
          >
            <img src={del} alt={del} />
          </Button>
        ) : (
          ""
        ),
    },
  ];

  // Колонка фактур для блока "Информация по начислениям счета-фактуры"
  const billFacturColumns = [
    {
      title: "Номер СФ",
      dataIndex: "invoiceExtNum",
      key: "invoiceExtNum",
    },
    {
      title: "Период",
      dataIndex: "period",
      key: "period",
      render: (period) => (
        <span>
          {period?.from} - {period?.to}
        </span>
      ),
    },
    {
      title: "Сумма СФ",
      dataIndex: "sum",
      key: "sum",
      render: (sum) => SpanNumberFormat({ amount: sum }),
    },
    {
      title: "НДС СФ",
      dataIndex: "taxSum",
      key: "taxSum",
      render: (taxSum) => SpanNumberFormat({ amount: taxSum }),
    },
    {
      title: "Дата СФ",
      dataIndex: "invoiceDate",
      key: "invoiceDate",
      render: (invoiceDate) => (invoiceDate ? toDisplayFormat(invoiceDate) : ""),
    },
    {
      title: "Статус СФ",
      dataIndex: "status",
      key: "status",
    },
  ];
  // Колонка фактур для блока "Информация по начислениям корректировочного счета-фактуры"
  const billFacturColumnsMainFacturCharges = [
    {
      title: "Номер СФ",
      dataIndex: "invoiceExtNum",
      key: "invoiceExtNum",
    },
    {
      title: "Период",
      dataIndex: "period",
      key: "period",
      render: (period) => (
        <span>
          {period?.from} - {period?.to}
        </span>
      ),
    },
    {
      title: "Сумма СФ",
      dataIndex: "sum",
      key: "sum",
      render: (sum) => SpanNumberFormat({ amount: sum }),
    },
    {
      title: "НДС СФ",
      dataIndex: "taxSum",
      key: "taxSum",
      render: (taxSum) => SpanNumberFormat({ amount: taxSum }),
    },
    {
      title: "Дата СФ",
      dataIndex: "invoiceDate",
      key: "invoiceDate",
      render: (invoiceDate) => (invoiceDate ? toDisplayFormat(invoiceDate) : ""),
    },
    {
      title: "Статус СФ",
      dataIndex: "status",
      key: "status",
      render: (status, record) => {
        return record.sum !== 0 ? status : null;
      },
    },
  ];

  const billColumns = [
    {
      title: "Номер счёта",
      dataIndex: "billNumber",
      key: "billNumber",
    },
    {
      title: "Период",
      dataIndex: "period",
      key: "period",
      render: (period) => (
        <span>
          {period?.from} - {period?.to}
        </span>
      ),
    },
    {
      title: "Сумма счёта",
      dataIndex: "billAmount",
      key: "billAmount",
      render: (billAmount) => SpanNumberFormat({ amount: billAmount }),
    },
    {
      title: "НДС",
      dataIndex: "billTax",
      key: "billTax",
      render: (billTax) => SpanNumberFormat({ amount: billTax }),
    },
    {
      title: "Дата счёта",
      dataIndex: "billFromDate",
      key: "billFromDate",
      render: (billFromDate) => (billFromDate ? toDisplayFormat(billFromDate) : ""),
    },
    {
      title: "Статус оплаты счёта",
      dataIndex: "billPayStatus",
      key: "billPayStatus",
      render: (billPayStatus, record) => {
        return record?.billAmount === 0 ? null : billPayStatus;
      },
    },
  ];

  const quantitySum =
    adjustments &&
    adjustments.length !== 0 &&
    adjustments.reduce((sum, cur) => sum + Number(cur.chargeUnits), 0);
  const quantity = quantitySum + charge?.chargeUnits;

  const amountSum =
    adjustments &&
    adjustments.length !== 0 &&
    adjustments.reduce((sum, cur) => sum + Number(cur.chargeAmount), 0);

  const amount = amountSum + charge?.chargeAmount;

  const taxSum =
    adjustments &&
    adjustments.length !== 0 &&
    adjustments.reduce((sum, cur) => sum + Number(cur.chargeTax), 0);
  const tax = taxSum + charge?.chargeTax;

  const handleDelete = async () => {
    setVisibleModalConfirm(false);
    dispatch(
      handleCheckUrlForRemovingChargeSessionStorage({
        url: `/accounts/${localStore?.accountId}/charges` || "/charges",
      })
    );
    await dispatch(
      deleteAdjustment({
        queryString: buildQueryStringWithObjectParams({
          transactionId: adjustmentRecord?.chargeId ? adjustmentRecord?.chargeId : "",
        }),
      })
    );
    if (adjustmentCountForCheckBeforeRemove && adjustmentCountForCheckBeforeRemove?.length === 0) {
      history.push(
        localStore?.accountId ? `/accounts/${localStore?.accountId}/charges` : "/charges"
      );
    } else {
      dispatch(fetchChargesDetails({ chargeId: charge?.chargeId }));
      history.replace(`/charges-details/${charge?.chargeId}`);
    }
  };

  const handleFormSubmit = () => {
    form
      .validateFields()
      .then(() => {
        message.loading("Создание корректировки");
        setIsAddQuest(true);

        dispatch(
          recreateFinancialDocumentsPatch({
            transactionId: charge?.chargeId,
            units: dataForm?.units ? Number(dataForm?.units) : "",
            amount: dataForm?.amount ? Number(dataForm?.amount) : "",
            dsc: dataForm?.dsc,
          })
        )
          .then(() => {
            message.destroy();
            Modal.warning({
              content: (
                <Row>
                  Задание создано. Пожалуйста, дождитесь выполнения. При отсутствии изменений в
                  течении 5 минут обратитесь в службу технического сопровождения.
                </Row>
              ),
            });
            setTimeout(() => {
              dispatch(fetchChargesDetails({ chargeId: charge?.chargeId }));
              setIsAddQuest(false);
            }, 12e3);
          })
          .catch((e) => {
            setIsAddQuest(false);
            throw e;
          });
        handleModalCancel();
      })
      .catch((e) => {
        throw e;
      });
  };

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  const onBack = () => {
    history.push(localStore?.accountId ? `/accounts/${localStore?.accountId}/charges` : "/charges");
    dispatch(
      handleCheckUrlForRemovingChargeSessionStorage({
        url: `/accounts/${localStore?.accountId}/charges` || "/charges",
      })
    );
  };

  const closeCorrectiveInvoiceModal = () => {
    setVisibleCorrectiveInvoiceModal(false);
    formCorrectiveInvoice.resetFields();
  };

  const closeSubmitCorrectiveInvoiceModal = () => {
    setVisibleSubmitCorrectiveInvoiceModal(false);
  };

  const submitCorrectiveInvoice = (values) => {
    setIsFirstClick(true);
    setIsAddQuest(true);
    const filledValues = Object.entries(values).reduce((res, [key, value]) => {
      if (value) res[key] = value;
      return res;
    }, {});
    const data = { ...filledValues, transactionId: charge.chargeId };
    if (filledValues.effectiveDate) {
      data.effectiveDate = toHttpFormatStartOfDay(filledValues.effectiveDate);
    } else {
      data.effectiveDate = toHttpFormatStartOfDay(moment());
    }
    const url = `${baseUrl}/processes-api/processes/create-correction-invoice`;
    message.loading("Создание корректировочного счета-фактуры");

    // return console.log(data);

    axios
      .post(url, data)
      .then(() => {
        message.destroy();
        Modal.warning({
          content:
            "Задание создано. При отсутствии изменений в течении 5 минут, пожалуйста обратитесь в службу технического сопровождения.",
        });
        setTimeout(() => {
          dispatch(fetchChargesDetails({ chargeId: charge.chargeId }));
          setIsAddQuest(false);
        }, 12e3);
      })
      .catch(() => {
        message.destroy();
        Modal.warning({
          content: "Ошибка создания корректировочного счета-фактуры",
        });
        setIsAddQuest(false);
      })
      .finally(() => {
        closeCorrectiveInvoiceModal();
        closeSubmitCorrectiveInvoiceModal();
        setIsFirstClick(false);
      });
  };

  // 0 - валидное значение. Количество не должно совпадать с Итого. Зависит от поля сумма.
  const validateUnits = (formInstance) => {
    const values = formInstance.getFieldsValue(["units", "amount"]);
    const hasUnits = Boolean(values.units);
    const hasAmount = Boolean(values.amount);
    const isUnitsEqualTotal = Number(values.units) === Number(quantity);
    const isAmountEqualTotal = Number(values.amount) === Number(amount);
    if (!hasUnits && !hasAmount) return Promise.reject();
    const error = new Error("Сумма корректировки будет равна 0");
    if (hasUnits && !hasAmount) {
      return isUnitsEqualTotal ? Promise.reject(error) : Promise.resolve();
    }
    if (isUnitsEqualTotal && isAmountEqualTotal) return Promise.reject(error);
    return Promise.resolve();
  };

  // 0 - валидное значение. Количество не должно совпадать с Итого. Зависит от поля количество.
  const validateAmount = (formInstance) => {
    const values = formInstance.getFieldsValue(["units", "amount"]);
    const hasUnits = Boolean(values.units);
    const hasAmount = Boolean(values.amount);
    const isUnitsEqualTotal = Number(values.units) === Number(quantity);
    const isAmountEqualTotal = Number(values.amount) === Number(amount);
    if (!hasUnits && !hasAmount) return Promise.reject();
    const error = new Error("Сумма корректировки будет равна 0");
    if (!hasUnits && hasAmount) {
      return isAmountEqualTotal ? Promise.reject(error) : Promise.resolve();
    }
    if (isUnitsEqualTotal && isAmountEqualTotal) return Promise.reject(error);
    return Promise.resolve();
  };

  const renderCorrectiveInvoiceModal = () => {
    const openSubmitCorrectiveInvoiceModal = () => {
      formCorrectiveInvoice.validateFields().then(() => {
        setVisibleSubmitCorrectiveInvoiceModal(true);
      });
    };

    return (
      <ModalWindow
        visible={visibleCorrectiveInvoiceModal}
        title="Итого по начислению"
        width={500}
        handleCancel={closeCorrectiveInvoiceModal}
        className="modal-charge-edit"
        footerHide
      >
        <Form
          name="dynamic_form_nest_item"
          form={formCorrectiveInvoice}
          autoComplete="off"
          onFinish={submitCorrectiveInvoice}
          {...layout}
        >
          <div>
            <Form.Item label="Продукт" name="serviceId" labelAlign="left">
              <div>{charge.serviceId ? charge?.serviceTypeName : charge?.chargeName}</div>
            </Form.Item>
          </div>

          <div>
            <Form.Item label="Предложение" name="offeringName" labelAlign="left">
              <div>{charge.offeringName ? charge?.offeringName : charge?.chargeName}</div>
            </Form.Item>
          </div>

          <Form.Item label="Период" name="period" labelAlign="left">
            <div>
              {charge.chargePeriodFrom ? toDisplayFormat(charge.chargePeriodFrom) : ""} -{" "}
              {charge.chargePeriodTo ? toDisplayFormat(charge.chargePeriodTo) : ""}
            </div>
          </Form.Item>
          <Form.Item
            labelAlign="left"
            className="charges-details-multiLabel"
            label={
              <span>
                Номер
                <br />
                корректировочного
                <br />
                счета-фактуры
              </span>
            }
            name="extNum"
          >
            <Input maxLength={255} placeholder="Введите номер" />
          </Form.Item>
          <Form.Item
            labelAlign="left"
            className="charges-details-multiLabel"
            label={
              <span>
                Дата
                <br />
                корректировочного
                <br />
                счета-фактуры
              </span>
            }
            name="effectiveDate"
          >
            <DatePicker disabledDate={(current) => current.isBefore(moment(charge?.invoiceDate))} />
          </Form.Item>
          <Form.Item
            label="Новое количество"
            name="units"
            dependencies={["amount"]}
            rules={[
              {
                validator: () => validateUnits(formCorrectiveInvoice),
              },
            ]}
            labelAlign="left"
          >
            <InputNumberFormat
              decimalScale={0}
              allowNegative={false}
              placeholder="Введите количество"
            />
          </Form.Item>
          <Form.Item
            label="Новая сумма"
            name="amount"
            dependencies={["units"]}
            rules={[
              {
                validator: () => validateAmount(formCorrectiveInvoice),
              },
            ]}
            labelAlign="left"
          >
            <InputNumberFormat placeholder="Введите сумму" allowNegative={false} />
          </Form.Item>
          <Form.Item label="Комментарий" name="dsc" labelAlign="left">
            <Input.TextArea placeholder="Введите текст" />
          </Form.Item>
          <Form.Item align="center" className="dictionary-modal__footer">
            <Button style={styles.btn} onClick={closeCorrectiveInvoiceModal}>
              Отмена
            </Button>
            <Button style={styles.btn} type="primary" onClick={openSubmitCorrectiveInvoiceModal}>
              Сохранить
            </Button>
          </Form.Item>
        </Form>
      </ModalWindow>
    );
  };

  const renderSubmitCorrectiveInvoiceModal = () => (
    <Modal
      onCancel={closeSubmitCorrectiveInvoiceModal}
      className="modal-charge-confirm"
      visible={visibleSubmitCorrectiveInvoiceModal}
      width={500}
      footer={[
        <Button key="1" onClick={closeSubmitCorrectiveInvoiceModal}>
          Отмена
        </Button>,
        <Button
          key="2"
          onClick={formCorrectiveInvoice.submit}
          type="primary"
          disabled={isFirstClick}
        >
          Подтвердить
        </Button>,
      ]}
    >
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <span style={{ fontSize: "16px" }}>
          Будет сформировано задание на создание корректировочного счета-фактуры
          <br />
          Вы подтверждаете исправление?
        </span>
      </div>
    </Modal>
  );

  // При переходе между начислениями фио берется из стора accounts.account. Если аккаунт изменится, значение предыдущего аккаунта проскакивать не будет.
  const clientFullName =
    account.id === chargesDetails?.resultSearchChargeByTransactionID?.accountId
      ? getAccountFullName(account)
      : "";

  // Получение даты предыдущего месяца
  const previousMonth = moment().subtract(1, "month").startOf("month");

  // Получение даты chargePeriodTo
  const chargePeriodTo = moment(charge?.chargePeriodTo);

  // Проверка, является ли chargePeriodTo ранее чем 1 число предыдущего месяца
  const checkClosePayPeriod = chargePeriodTo.isBefore(previousMonth, "month");

  console.log({ dataAdjustments });

  return (
    <div className="inner-row charges-details">
      <Row>
        <Row>
          <h1>Детали начислений</h1>
          <Button style={{ marginLeft: "15px", marginTop: "4px" }} onClick={onBack}>
            Назад
          </Button>
        </Row>
        <Space size="large" className="charges-details__header_space">
          <Space>
            Аккаунт:
            <span className="charges-details__property-value">{clientFullName}</span>
          </Space>
          <Space>
            Договор:
            <span className="charges-details__property-value">
              {`${agreement?.agreementNumber ? agreement?.agreementNumber : ""} от ${agreement?.fromDate ? toDisplayFormat(agreement?.fromDate) : ""
                }`}
            </span>
          </Space>
        </Space>
      </Row>

      <div>
        <Row align="middle" style={{ fontSize: "14px", margin: "6px 0px 12px" }}>
          <Col span={2}>
            <span
              style={{
                fontSize: "18px",
                marginRight: "25px",
                position: "relative",
                top: "-2px",
              }}
            >
              Итого:
            </span>
          </Col>
          <Col span={2}>
            <Row>
              <label className="charges-details__label">Кол-во</label>
              <span>{SpanNumberFormat({ amount: quantity, fractSize: 0 })}</span>
            </Row>
          </Col>
          <Col span={3}>
            <Row justify="center">
              <label className="charges-details__label">Сумма</label>
              <span>{SpanNumberFormat({ amount })}</span>
            </Row>
          </Col>
          <Col span={2}>
            <Row justify="center">
              <label className="charges-details__label">НДС </label>
              <span>{SpanNumberFormat({ amount: tax })}</span>
            </Row>
          </Col>
          <Col>
            <Row justify="center">
              {charge.isAdjustment === 0 && charge.taxInvoiceId > 0 && (
                <Tooltip title="Корректировочный счет-фактура">
                  <Button
                    icon={<img src={pencilPlus} width="14px" alt="pencilPlus" />}
                    type="text"
                    htmlType="button"
                    onClick={() => setVisibleCorrectiveInvoiceModal(true)}
                    style={styles.buttonIcon}
                    disabled={isAddQuest}
                  />
                </Tooltip>
              )}
              {charge.isAdjustment === 0 && hasNoTaxInvoiceAdjustment && (
                <Tooltip title="Редактировать">
                  <Button
                    icon={<img src={pencilIcon} width="14px" alt="pencil" />}
                    type="text"
                    htmlType="button"
                    onClick={() => editModal()}
                    style={styles.buttonIcon}
                    disabled={isAddQuest}
                  />
                </Tooltip>
              )}
            </Row>
          </Col>
        </Row>

        <h3 className="heading-2">Информация по начислениям</h3>
        <div
          style={{
            border: "1px solid #DEDEDE",
            marginTop: "18px",
            marginBottom: "20px",
            boxShadow: "0 1px 6px rgb(0 0 0 / 16%)",
          }}
        >
          <Table
            size="small"
            columns={chargesAndAdjustmentsInfoTableColumns}
            dataSource={newDataChargesAdjustments}
            pagination={false}
            loading={checkIsLoading(chargesDetailsLoading) || isAddQuest}
          />

          {dataChargesBillFactur.length > 0 && (
            <Table
              title={() => <h3 className="heading-3">Учтено в счете-фактуре</h3>}
              size="small"
              className="charges-details__table"
              columns={billFacturColumns}
              dataSource={dataChargesBillFactur}
              pagination={false}
              loading={checkIsLoading(chargesDetailsLoading) || isAddQuest}
            />
          )}

          {dataChargesBill.length > 0 && (
            <Table
              title={() => <h3 className="heading-3">Учтено в счете</h3>}
              size="small"
              className="charges-details__table"
              columns={billColumns}
              dataSource={dataChargesBill}
              pagination={false}
              loading={checkIsLoading(chargesDetailsLoading) || isAddQuest}
            />
          )}
        </div>

        {dataAdjustments.length > 0 && (
          <h3 className="heading-2">Информация по начислениям корректировочного счета-фактуры</h3>
        )}
        {dataAdjustments.map((dataAdjustmentsItem) => (
          <div
            key={dataAdjustmentsItem.adjustments[0].chargeId}
            style={{
              border: "1px solid #DEDEDE",
              marginTop: "18px",
              marginBottom: "20px",
              boxShadow: "0 1px 6px rgb(0 0 0 / 15%)",
            }}
          >
            <Table
              size="small"
              columns={chargesAndAdjustmentsInfoTableColumns}
              dataSource={dataAdjustmentsItem.adjustments}
              pagination={false}
              loading={checkIsLoading(chargesDetailsLoading) || isAddQuest}
            />

            {dataAdjustmentsItem.billFactures.length > 0 && (
              <Table
                title={() => <h3 className="heading-3">Учтено в счете-фактуре</h3>}
                size="small"
                className="charges-details__table"
                columns={billFacturColumnsMainFacturCharges}
                dataSource={dataAdjustmentsItem.billFactures}
                pagination={false}
                loading={checkIsLoading(chargesDetailsLoading) || isAddQuest}
              />
            )}

            {dataAdjustmentsItem.bills.length > 0 && (
              <Table
                title={() => <h3 className="heading-3">Учтено в счете</h3>}
                size="small"
                className="charges-details__table"
                columns={billColumns}
                dataSource={dataAdjustmentsItem.bills}
                pagination={false}
                loading={checkIsLoading(chargesDetailsLoading || isAddQuest)}
              />
            )}
          </div>
        ))}

        <ModalWindow
          visible={visibleModal}
          title={
            <>
              {checkClosePayPeriod ? (
                <Row>
                  <Col style={{ display: "flex", alignItems: "end", marginRight: 5 }}>
                    <WarningIco style={{}} />
                  </Col>
                  <Col>
                    <div>Итого по начислению</div>
                    <div style={{ marginTop: 6 }}>Вы исправляете закрытый расчетный период</div>
                  </Col>
                </Row>
              ) : (
                "Итого по начислению"
              )}
            </>
          }
          width={500}
          handleCancel={handleModalCancel}
          className="modal-charge-edit"
          footerHide
        >
          <Form name="dynamic_form_nest_item" form={form} autoComplete="off" {...layout}>
            <div>
              <Form.Item label="Продукт" name="serviceId" labelAlign="left">
                <div>{charge.serviceId ? charge?.serviceTypeName : charge?.chargeName}</div>
              </Form.Item>
            </div>

            <div>
              <Form.Item label="Предложение" name="offeringName" labelAlign="left">
                <div>{charge.offeringName ? charge?.offeringName : charge?.chargeName}</div>
              </Form.Item>
            </div>

            <Form.Item label="Период" name="period" labelAlign="left">
              <div>
                {charge?.chargePeriodFrom ? toDisplayFormat(charge?.chargePeriodFrom) : ""} -{" "}
                {charge?.chargePeriodTo ? toDisplayFormat(charge?.chargePeriodTo) : ""}
              </div>
            </Form.Item>
            <Form.Item
              label="Новое количество"
              name="units"
              dependencies={["amount"]}
              rules={[
                {
                  validator: () => validateUnits(form),
                },
              ]}
              labelAlign="left"
            >
              <InputNumberFormat
                onChange={(units) =>
                  setDataForm({
                    ...dataForm,
                    units,
                  })
                }
                decimalScale={0}
                allowNegative={false}
              />
            </Form.Item>
            <Form.Item
              label="Новая сумма"
              name="amount"
              dependencies={["units"]}
              rules={[
                {
                  validator: () => validateAmount(form),
                },
              ]}
              labelAlign="left"
            >
              <InputNumberFormat
                onChange={(value) =>
                  setDataForm({
                    ...dataForm,
                    amount: value,
                  })
                }
                allowNegative={false}
              />
            </Form.Item>
            <Form.Item label="Комментарий" name="dsc" labelAlign="left">
              <Input.TextArea
                onChange={(e) =>
                  setDataForm({
                    ...dataForm,
                    dsc: e.target.value,
                  })
                }
              />
            </Form.Item>
            <Form.Item align="center" className="dictionary-modal__footer">
              <Button style={styles.btn} onClick={handleModalCancel}>
                Отмена
              </Button>

              <Button style={styles.btn} type="primary" onClick={onShowCreateUpdateWindow}>
                Сохранить
              </Button>
            </Form.Item>
          </Form>
        </ModalWindow>

        <Modal
          onCancel={handleCreateUpdateModalCancel}
          className="modal-charge-confirm"
          visible={visibleModalConfirmCreateUpdate}
          width={500}
          title={
            checkClosePayPeriod ? (
              <Row style={{ marginBottom: "-10px" }}>
                <WarningIco style={{ paddingBottom: 5 }} />
                <div>Вы исправляете закрытый расчетный период</div>
              </Row>
            ) : null
          }
          footer={[
            <Button key="1" onClick={handleCreateUpdateModalCancel}>
              Отмена
            </Button>,
            <Button key="2" onClick={handleFormSubmit} type="primary">
              Подтвердить
            </Button>,
          ]}
        >
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            {!charge?.invoiceExtNum ? (
              <span style={{ fontSize: "16px" }}>
                Будет сформировано задание на исправление начислений.
                <br />
                Вы подтверждаете исправление?
              </span>
            ) : (
              <span style={{ fontSize: "16px" }}>
                Будет сформировано задание на исправление начислений и закрывающих документов.
                <br />
                Вы подтверждаете исправление?
              </span>
            )}
          </div>
        </Modal>

        <ModalWindow
          visible={visibleModalConfirm}
          width={500}
          handleCancel={handleModalCancel}
          className="modal-charge-confirm"
          handleSubmit={() => handleDelete()}
          handleReset={handleModalCancel}
          cancelTextButton="Отмена"
          submitTextButton="Подтвердить"
        >
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <span style={{ fontSize: "16px" }}>Вы подтверждаете удаление корректировки?</span>
          </div>
        </ModalWindow>
        {renderCorrectiveInvoiceModal()}
        {renderSubmitCorrectiveInvoiceModal()}
      </div>
    </div>
  );
};

export default ChargesDetails;
